import React, { useEffect, useContext, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { SuiZkLoginService } from '../utils/suiZkLogin';

const ZkGoogleCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(true);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // 防止 React StrictMode 重複執行
    if (hasProcessed.current) {
      return;
    }

    const handleCallback = async () => {
      hasProcessed.current = true;

      // 取得 Google 回傳的 id_token（在 URL fragment 中，不是 query parameters）
      const hash = window.location.hash.substring(1); // 移除 # 符號
      const hashParams = new URLSearchParams(hash);
      const id_token = hashParams.get('id_token');

      console.log('處理 zkLogin callback, id_token:', id_token?.substring(0, 50) + '...');

      // 檢查是否已處理過此 token
      const processedToken = sessionStorage.getItem('processed_jwt');
      if (processedToken === id_token && id_token) {
        console.log('此 JWT 已經處理過，直接導向遊戲頁面');
        navigate('/20sui');
        return;
      }

      if (id_token) {
        try {
          // 立即標記為處理中，防止重複
          sessionStorage.setItem('processed_jwt', id_token);

          console.log('開始處理 zkLogin...');
          
          // 創建 zkLogin 服務
          const zkLoginService = new SuiZkLoginService({
            mockMode: false, // 使用真實模式
            network: 'devnet',
            clientId: '662787757849-u2s075t0kfj450fus2hs13224ch0318d.apps.googleusercontent.com',
            redirectUri: window.location.origin + '/gl-sui'
          });
          
          // 處理 OAuth callback
          const result = await zkLoginService.handleOAuthCallback(id_token);
          
          if (result.success) {
            console.log('zkLogin 成功:', result);
            
            // 成功後清除標記
            sessionStorage.removeItem('processed_jwt');

            sessionStorage.setItem('zklogin_user_address', result.zkLoginUserAddress);
            sessionStorage.setItem('zklogin_extended_ephemeral_public_key', result.extendedEphemeralPublicKey);
            console.log('result.zkProof:', result.zkProof);
            sessionStorage.setItem('zk_prove', JSON.stringify(result.zkProof));

            navigate('/20sui');
          } else {
            throw new Error('zkLogin 處理失敗');
          }
          
        } catch (error) {
          console.error('處理 zkLogin 失敗:', error);
          
          // 失敗時清除標記，允許重試
          sessionStorage.removeItem('processed_jwt');
          
          setError(`登入處理失敗: ${error.message}`);
          setIsProcessing(false);
          
          // 5秒後重新導向到遊戲頁面
          setTimeout(() => {
            navigate('/20sui');
          }, 5000);
        }
      } else {
        console.error('未找到 id_token');
        setError('登入回調參數錯誤');
        setIsProcessing(false);
        
        // 3秒後重新導向到遊戲頁面
        setTimeout(() => {
          navigate('/20sui');
        }, 3000);
      }
    };

    // 延遲一點執行，確保只執行一次
    const timer = setTimeout(handleCallback, 50);
    
    return () => {
      clearTimeout(timer);
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="text-center">
          <div className="alert alert-danger" role="alert">
            <h5>❌ 登入失敗</h5>
            {error}
          </div>
          <p>即將返回遊戲頁面...</p>
          <div className="spinner-border spinner-border-sm text-muted" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (isProcessing) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <h4>🔐 處理 SUI zkLogin 中...</h4>
          <p>正在驗證您的身份並生成 zkLogin 證明</p>
          <div className="mt-3">
            <small className="text-muted">這可能需要幾秒鐘時間...</small>
          </div>
        </div>
      </div>
    );
  }

  // 成功情況下會自動重新導向，這裡是備用顯示
  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
      <div className="text-center">
        <div className="alert alert-success" role="alert">
          <h5>✅ 登入成功！</h5>
          正在重新導向到遊戲頁面...
        </div>
      </div>
    </div>
  );
};

export default ZkGoogleCallback;
